export const getRateResponseValidationErrorMeta = (providerRates) => {
  const errMessage = providerRates?.errorMessage || '';
  const hasDimensionsError =
    errMessage.indexOf('height') >= 0 ||
    errMessage.indexOf('length') >= 0 ||
    errMessage.indexOf('width') >= 0 ||
    errMessage.indexOf('dimensions') >= 0;
  return {
    hasDimensionsError,
  };
};
